// MESSAGES
import FormattedMessages from '../messages/account/UsersFormattedMessages';

export const AccountRoutes = [
  {
    path: '/account/administrators',
    label: FormattedMessages.admin,
  },
  {
    path: '/account/cost-centers',
    label: FormattedMessages.costCenters,
  },
  {
    path: '/account/users',
    label: FormattedMessages.users,
  },
  {
    path: '/account/company-profile',
    label: FormattedMessages.companyProfile,
  },
];
